import { render, staticRenderFns } from "./MedicalDetail.vue?vue&type=template&id=54273088&scoped=true&"
import script from "./MedicalDetail.vue?vue&type=script&lang=js&"
export * from "./MedicalDetail.vue?vue&type=script&lang=js&"
import style0 from "./MedicalDetail.vue?vue&type=style&index=0&id=54273088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54273088",
  null
  
)

export default component.exports